import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconGroup: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        d="M23.3607 5.66491L18.0333 0.606955C17.6337 0.227608 17.0744 0 16.4883 0H2.1576C0.958935 0 0 0.910432 0 2.04847V21.9515C0 23.0896 0.958935 24 2.1576 24H21.8424C23.0411 24 24 23.0896 24 21.9515V7.13172C24 6.57534 23.7603 6.04426 23.3607 5.66491ZM7.64484 4.65332C7.64484 4.22339 8.01776 3.86934 8.47059 3.86934H15.4761C15.929 3.86934 16.3019 4.22339 16.3019 4.65332V9.43309C16.3019 9.86301 15.929 10.2171 15.4761 10.2171H8.49723C8.0444 10.2171 7.67148 9.86301 7.67148 9.43309V4.65332H7.64484ZM18.6193 19.372C18.6193 19.8019 18.2464 20.156 17.7936 20.156H6.1798C5.72697 20.156 5.35405 19.8019 5.35405 19.372V14.1623C5.35405 13.7323 5.72697 13.3783 6.1798 13.3783H17.7669C18.2198 13.3783 18.5927 13.7323 18.5927 14.1623V19.372H18.6193Z"
        fill="#262626"
      />
    </Icon>
  );
};

export default IconGroup;
